/* km-kundentyp.js · Kirchberger Metall · 02.10.2026
   Angebotsformulare (Konfiguratoren und Warenkorb): vor der Adresse steht die Frage
   "Privatkunde oder Gewerbekunde". Erst nach der Wahl erscheinen die Adressfelder.
   Privat: Firma und USt-IdNr. ausgeblendet und leer -> der Workflow behandelt die Anfrage als Privatkunde.
   Gewerbe: Firma ist Pflicht.
   Anlass: Kunde schrieb "privat" ins Firmenfeld und wurde als Gewerbe eingestuft (02.10.2026).
   Greift auf jedes Formular .km-modal__form mit den Feldern firma und vorname. Die Formular-Skripte
   (km-konfigurator-anfrage.js, km-warenkorb-angebot.js, km-gelaender.js, km-ausstattung.js) bleiben unveraendert:
   die Pruefung laeuft vorher im Capture-Listener auf document. */
(function () {
  'use strict';
  if (window.kmKundentyp) return;
  window.kmKundentyp = true;

  var CSS = ''
    + '.km-kt{border:0;margin:0 0 1rem;padding:0;min-width:0}'
    + '.km-kt__frage{font-weight:600;color:#01014d;margin:0 0 .5rem;padding:0;font-size:1rem}'
    + '.km-kt__frage b{color:#b91c1c;font-weight:600}'
    + '.km-kt__wahl{display:grid;grid-template-columns:1fr 1fr;gap:.6rem}'
    + '.km-kt__opt{position:relative;display:block;cursor:pointer}'
    + '.km-kt__opt input{position:absolute;opacity:0;width:1px;height:1px}'
    + '.km-kt__opt span{display:flex;flex-direction:column;gap:.15rem;height:100%;box-sizing:border-box;padding:.75rem .9rem;border:1px solid #d1d5db;border-radius:10px;background:#fff;transition:border-color .15s,box-shadow .15s}'
    + '.km-kt__opt strong{color:#01014d;font-size:.98rem}'
    + '.km-kt__opt small{color:#6b7280;font-size:.8rem;line-height:1.35}'
    + '.km-kt__opt:hover span{border-color:#01014d}'
    + '.km-kt__opt input:checked+span{border-color:#01014d;box-shadow:0 0 0 2px rgba(1,1,77,.15);background:#f5f6fb}'
    + '.km-kt__opt input:focus-visible+span{outline:2px solid #01014d;outline-offset:2px}'
    + '.km-kt.is-fehler .km-kt__opt span{border-color:#b91c1c}'
    + '.km-kt-zu>.km-kt~*:not(.km-hp){display:none!important}'
    + '.km-kt-privat .km-kt-firma,.km-kt-privat .km-fld--ustid{display:none!important}'
    + '@media (max-width:420px){.km-kt__wahl{grid-template-columns:1fr}}';

  function stil() {
    if (document.getElementById('km-kt-css')) return;
    var s = document.createElement('style');
    s.id = 'km-kt-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function fehlerFeld(form) { return form.querySelector('.km-modal__err'); }
  function zeigeFehler(form, text) {
    var f = fehlerFeld(form);
    if (f) { f.textContent = text; f.hidden = false; f.scrollIntoView({ block: 'nearest' }); }
  }

  function wahl(form) {
    var r = form.querySelector('input[name="kundentyp"]:checked');
    return r ? r.value : '';
  }

  function anwenden(form) {
    var w = wahl(form);
    var firma = form.elements['firma'];
    var ust = form.elements['ustid'];
    form.classList.toggle('km-kt-zu', !w);
    form.classList.toggle('km-kt-privat', w === 'privat');
    form.classList.toggle('km-kt-gewerbe', w === 'gewerbe');
    var hinweis = form.querySelector('.km-kt-firma small, .km-kt-firma b');
    if (hinweis) {
      var neu = document.createElement(w === 'gewerbe' ? 'b' : 'small');
      if (w === 'gewerbe') { neu.setAttribute('aria-hidden', 'true'); neu.textContent = '*'; } else { neu.textContent = '(optional)'; }
      hinweis.parentNode.replaceChild(neu, hinweis);
    }
    if (firma) firma.required = (w === 'gewerbe');
    if (w === 'privat') {
      if (firma) firma.value = '';
      if (ust) ust.value = '';
    }
  }

  function init(form) {
    if (form.getAttribute('data-km-kt')) return;
    var firma = form.elements['firma'];
    if (!firma || !form.elements['vorname']) return;
    var grid = form.querySelector(':scope > .km-modal__grid');
    if (!grid) return;
    form.setAttribute('data-km-kt', '1');
    var firmaLabel = firma.closest('label');
    if (firmaLabel) firmaLabel.classList.add('km-kt-firma');

    var box = document.createElement('fieldset');
    box.className = 'km-kt';
    box.innerHTML = ''
      + '<legend class="km-kt__frage">Sie fragen an als <b aria-hidden="true">*</b></legend>'
      + '<div class="km-kt__wahl">'
      + '<label class="km-kt__opt"><input type="radio" name="kundentyp" value="privat" required>'
      + '<span><strong>Privatkunde</strong><small>für Ihr Haus oder Ihre Wohnung</small></span></label>'
      + '<label class="km-kt__opt"><input type="radio" name="kundentyp" value="gewerbe">'
      + '<span><strong>Gewerbekunde</strong><small>Firma, Behörde, Verein oder Verwaltung</small></span></label>'
      + '</div>';
    form.insertBefore(box, grid);

    box.addEventListener('change', function () {
      box.classList.remove('is-fehler');
      var f = fehlerFeld(form);
      if (f) f.hidden = true;
      anwenden(form);
      var ziel = wahl(form) === 'gewerbe' ? form.elements['firma'] : form.elements['vorname'];
      if (ziel && ziel.focus) ziel.focus();
    });
    form.addEventListener('reset', function () { setTimeout(function () { anwenden(form); }, 0); });
    anwenden(form);
  }

  // Pruefung vor den Formular-Skripten: Capture auf document laeuft vor den Listenern am Formular.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute || !form.getAttribute('data-km-kt')) return;
    var w = wahl(form);
    var stopp = function (text, feld) {
      e.preventDefault();
      e.stopImmediatePropagation();
      zeigeFehler(form, text);
      if (feld && feld.focus) feld.focus();
    };
    if (!w) {
      form.querySelector('.km-kt').classList.add('is-fehler');
      return stopp('Bitte wählen Sie, ob Sie als Privatkunde oder als Gewerbekunde anfragen.', form.querySelector('input[name="kundentyp"]'));
    }
    var firma = form.elements['firma'];
    if (w === 'gewerbe' && firma && !String(firma.value || '').trim()) {
      firma.setAttribute('aria-invalid', 'true');
      return stopp('Bitte geben Sie den Namen Ihrer Firma, Behörde oder Ihres Vereins an.', firma);
    }
    if (w === 'privat') {
      if (firma) firma.value = '';
      if (form.elements['ustid']) form.elements['ustid'].value = '';
    }
  }, true);

  function alle() {
    stil();
    var forms = document.querySelectorAll('form.km-modal__form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  // Formulare, die spaeter in die Seite kommen (Warenkorb-Drawer, Modal nachgeladen)
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (document.querySelector('form.km-modal__form:not([data-km-kt])')) alle();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
